// the resolution determines the maxDataPoints of the query runner (e.g. see src/GmdVizPanel/statushistory/getStatushistoryQueryRunnerParams.ts)
export enum QUERY_RESOLUTION {
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
}
